var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client",
    attrs: {
      "data-testid": "client-file"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientVisit') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientVisit'
      },
      "data-testid": "client-tab-visits"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Návštěvy")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-visits"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Návštěvy")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientAnamnesis') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientAnamnesis'
      },
      "data-testid": "client-tab-anamnesis"
    }
  }, [_c('i', {
    staticClass: "fa fa-notes-medical fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Anamnéza")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-anamnesis"
    }
  }, [_c('i', {
    staticClass: "fa fa-notes-medical fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Anamnéza")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientMedicament') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientMedicament'
      },
      "data-testid": "client-tab-medicaments"
    }
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Léky a recepty")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-medicaments"
    }
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Léky a recepty")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientMedicalReport') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientMedicalReport'
      },
      "data-testid": "client-tab-medical-reports"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lékařské zprávy")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-medical-reports"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lékařské zprávy")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientResult') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientResult'
      },
      "data-testid": "client-tab-results"
    }
  }, [_c('i', {
    staticClass: "fa fa-flask fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Laboratorní výsledky")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-results"
    }
  }, [_c('i', {
    staticClass: "fa fa-flask fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Laboratorní výsledky")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientTask') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientTask'
      },
      "data-testid": "client-tab-tasks"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Úkoly")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-tasks"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Úkoly")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientDocument') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientDocument'
      },
      "data-testid": "client-tab-document"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Dokumenty")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-document"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Dokumenty")])], 1)])]), _vm._v(" "), _c('router-view')], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9d3fff","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/ShowClient.vue
// module id = 491
// module chunks = 0